import React, { FunctionComponent } from 'react';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';

import useTypedSelector from 'hooks/useTypedSelector';
import { isUserLoggedInSelector } from 'redux/selectors/user.selector';
import { getCookie } from 'helpers/cookies';

interface IRouteContainerProps extends RouteProps {
  authenticated?: boolean;
  restricted?: boolean;
}

const RouteContainer: FunctionComponent<IRouteContainerProps> = ({
  component: Component,
  authenticated = false,
  restricted = false,
  ...rest
}) => {
  const location = useLocation();
  const isUserLoggedIn = useTypedSelector(isUserLoggedInSelector);

  if (!Component) return null;

  if (restricted && (getCookie('accessToken') || isUserLoggedIn)) {
    return <Redirect to={{ pathname: '/' }} />;
  }

  if (authenticated && !getCookie('accessToken') && !isUserLoggedIn) {
    return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default RouteContainer;
